import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const confirmRefund = http.post<
  refundApi.RefundRequestConfirmPathParams,
  refundApi.RefundConfirmRequest,
  refundApi.RefundConfirmResponse
>(apiBaseUrl + '/refunds/:refundId/confirm', async ({ request, params }) => {
  console.log('MSW: Confirm Refund called with refundId:', params.refundId)
  const body = await request.json()
  console.log('MSW: Confirm Refund called with body:', body)

  if (params.refundId === 'FAILED') {
    return HttpResponse.json({ status: { value: 'FAILED' } }, { status: 409 })
  } else if (params.refundId === 'CANCELED') {
    return HttpResponse.json({ status: { value: 'CANCELED' } })
  } else {
    return HttpResponse.json({ status: { value: 'SUBMITTED' } })
  }
})
